import { Injectable } from '@angular/core';

/**
 * Holds the access token handed to the embedded dashboard (/embed/dashboard#token=...).
 * Kept in memory only: it is never written to localStorage, so it dies with the iframe
 * and cannot be picked up by the admin panel running in another tab on the same origin.
 */
@Injectable({
  providedIn: 'root'
})
export class EmbedTokenService {
  token: string | null = null;

  get active(): boolean {
    return !!this.token;
  }
}
